import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=6e8953c6&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=6e8953c6&lang=css"

import exportComponent from "D:\\web_projects\\ArcSoftFaceDemoUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8953c6"]])

export default __exports__